import {createDataReducer} from "./createDataReducer";
import createGetModel from "./createGetModel";
import httpOpenInNewWindow from "./httpOpenInNewWindow";

export default {
    createDataReducer,
    createGetModel,
    httpOpenInNewWindow,
};
